import { toast } from "sonner";
import { handleOrganizationAccessError } from "./organization-access-errors";
import { getReadOnlyAccessMessage } from "./read-only-access-errors";

const READ_ONLY_TOAST_ID = "read-only-access";

/**
 * Route expected access denials to the shared dialog, preserving other error toasts. A reviewer's
 * refused write shows the server's explanation (once, however many calls fail) instead of the
 * caller's generic failure text.
 */
export function notifyError(error: unknown, ...args: Parameters<typeof toast.error>) {
  if (handleOrganizationAccessError(error)) return;
  const readOnlyMessage = getReadOnlyAccessMessage(error);
  if (readOnlyMessage) return toast.error(readOnlyMessage, { id: READ_ONLY_TOAST_ID });
  return toast.error(...args);
}
